export class TabConstants {
  static readonly PERSON: string = "PERSON";
  static readonly BRANCH_PERSON_ENROLLMENT: string = "BRANCH_PERSON_ENROLLMENT";
  static readonly BRANCH_BUSINESS_ENROLLMENT: string = "BRANCH_BUSINESS_ENROLLMENT";
  static readonly BRANCH_PERSON_INFO: string = "BRANCH_PERSON_INFO";
  static readonly BRANCH_BUSINESS_INFO: string = "BRANCH_BUSINESS_INFO";
}